
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_cc1pu_s1atg_1"
};
  